import { cn } from '@module/lib/utils';
import { JpBangStroke } from '@module/svg/icons';
import { Tooltip, TooltipContent, TooltipTrigger } from '@pc/components/ui/tooltip';
import { type ReactNode, useState } from 'react';

interface Props {
  content: ReactNode; // 툴팁에 표시될 ReactNode 타입의 내용
  iconSize?: number;
  position?: 'top' | 'bottom';
  containerClassName?: string;
  tipClassName?: string;
  escapeOverflow?: boolean;
}

function BaseTooltip({
  content,
  iconSize = 13,
  position = 'bottom',
  containerClassName,
  tipClassName,
  escapeOverflow,
}: Props) {
  const [showTooltip, setShowTooltip] = useState(false);

  // 기존 baseTooltip 컴포넌트는 부모 모달을 넘어갈경우 일부 가려지는 문제가 있어 radix ui tooltip 사용
  // 영향도를 고려하여 escapeOverflow true 일 경우 radix ui tooltip 사용. 부분적으로 적용하여 안정성이 확인되면 수정 예정
  return escapeOverflow ? (
    <div className={cn('relative flex items-center', containerClassName)}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button type='button'>
            <JpBangStroke style={{ fontSize: iconSize }} />
          </button>
        </TooltipTrigger>
        <TooltipContent
          side={position}
          align='center'
          sideOffset={position === 'bottom' ? 24 : 24}
          className={cn('z-50 rounded-md bg-[#616161e5] p-2 text-[15px] text-white', tipClassName)}
          style={{ animation: 'none', transition: 'none' }}
        >
          {content}
        </TooltipContent>
      </Tooltip>
    </div>
  ) : (
    <div className={cn('relative flex items-center', containerClassName)}>
      <button onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)} type='button'>
        <JpBangStroke style={{ fontSize: iconSize }} />
      </button>
      {showTooltip && (
        <div
          className={cn(
            '-translate-x-1/2 absolute z-50 rounded-md bg-[#616161e5] p-2 text-[15px] text-white',
            {
              'top-6': position === 'bottom',
              'bottom-6': position === 'top',
            },
            tipClassName,
          )}
        >
          {content}
        </div>
      )}
    </div>
  );
}

export default BaseTooltip;
